import React from 'react';
import Modal from '../utils/Modal/Modal';
import UserListItem from '../UserListItem/UserListItem';
import styles from './EmojiArray.module.scss';

const ReactionsModal = ({ isOpen, onClose, reactions, users }) => {
  if (!isOpen) return null;

  return (
    <Modal show={isOpen} onClose={onClose} size="small" title="Reactions">
      <div className={styles.reactionsList}>
        {reactions.map((reaction, idx) => {
          const user = users[reaction.userId];
          if (!user) return null;

          return (
            <UserListItem
              key={idx}
              user={user}
              isEmojiReaction={true}
              emoji={reaction.emoji}
              onCloseModal={onClose}
            />
          );
        })}
      </div>
    </Modal>
  );
};

export default ReactionsModal;
